"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.servicesSchemaMapper = servicesSchemaMapper;
function makeServiceSchema(title) {
    return {
        type: "number",
        title,
        oneOf: [
            { const: 1, title: "Add" },
            { const: 2, title: "Delete" },
        ],
    };
}
function makeServicesSchema(services, withFrequency) {
    const servicesSchema = {};
    services.forEach(service => {
        const { shortHand } = service;
        servicesSchema[shortHand] = makeServiceSchema(shortHand);
        const serviceFrequency = withFrequency === null || withFrequency === void 0 ? void 0 : withFrequency.find(serviceFrequency => serviceFrequency.service === shortHand);
        if (serviceFrequency) {
            servicesSchema[serviceFrequency.key] = {
                type: "string",
                title: serviceFrequency.title,
            };
        }
    });
    return servicesSchema;
}
function requireAtLeastOneField(services) {
    const anyOf = [];
    services.forEach(service => {
        anyOf.push({ required: [service.shortHand] });
    });
    return anyOf;
}
function servicesSchemaMapper(template, services, serviceFrequencies) {
    const servicesSchemaProperties = makeServicesSchema(services, serviceFrequencies);
    template.schema.properties = Object.assign(Object.assign({}, servicesSchemaProperties), template.schema.properties);
    template.schema.anyOf = requireAtLeastOneField(services);
    return template;
}
